(function () {
  class Grad {
    constructor(x, y, z) { this.x = x; this.y = y; this.z = z; }
    dot2(x, y) { return this.x * x + this.y * y; }
  }

  class Noise {
    constructor(seed = 0) {
      this.grad3 = [
        new Grad(1,1,0), new Grad(-1,1,0), new Grad(1,-1,0), new Grad(-1,-1,0),
        new Grad(1,0,1), new Grad(-1,0,1), new Grad(1,0,-1), new Grad(-1,0,-1),
        new Grad(0,1,1), new Grad(0,-1,1), new Grad(0,1,-1), new Grad(0,-1,-1)
      ];
      this.p = [151,160,137,91,90,15,131,13,201,95,96,53,194,233,7,225,140,36,103,30,69,142,8,99,37,240,
        21,10,23,190,6,148,247,120,234,75,0,26,197,62,94,252,219,203,117,35,11,32,57,177,33,88,
        237,149,56,87,174,20,125,136,171,168,68,175,74,165,71,134,139,48,27,166,77,146,158,231,83,
        111,229,122,60,211,133,230,220,105,92,41,55,46,245,40,244,102,143,54,65,25,63,161,1,216,
        80,73,209,76,132,187,208,89,18,169,200,196,135,130,116,188,159,86,164,100,109,198,173,186,
        3,64,52,217,226,250,124,123,5,202,38,147,118,126,255,82,85,212,207,206,59,227,47,16,58,
        17,182,189,28,42,223,183,170,213,119,248,152,2,44,154,163,70,221,153,101,155,167,43,172,9,
        129,22,39,253,19,98,108,110,79,113,224,232,178,185,112,104,218,246,97,228,251,34,242,193,
        238,210,144,12,191,179,162,241,81,51,145,235,249,14,239,107,49,192,214,31,181,199,106,157,
        184,84,204,176,115,121,50,45,127,4,150,254,138,236,205,93,222,114,67,29,24,72,243,141,128,
        195,78,66,215,61,156,180];
      this.perm = new Array(512);
      this.gradP = new Array(512);
      this.seed(seed);
    }
    seed(seed) {
      if (seed > 0 && seed < 1) seed *= 65536;
      seed = Math.floor(seed);
      if (seed < 256) seed |= seed << 8;
      for (let i = 0; i < 256; i++) {
        const v = i & 1 ? this.p[i] ^ (seed & 255) : this.p[i] ^ ((seed >> 8) & 255);
        this.perm[i] = this.perm[i + 256] = v;
        this.gradP[i] = this.gradP[i + 256] = this.grad3[v % 12];
      }
    }
    fade(t) { return t * t * t * (t * (t * 6 - 15) + 10); }
    lerp(a, b, t) { return (1 - t) * a + t * b; }
    perlin2(x, y) {
      let X = Math.floor(x), Y = Math.floor(y);
      x -= X; y -= Y; X &= 255; Y &= 255;
      const n00 = this.gradP[X + this.perm[Y]].dot2(x, y);
      const n01 = this.gradP[X + this.perm[Y + 1]].dot2(x, y - 1);
      const n10 = this.gradP[X + 1 + this.perm[Y]].dot2(x - 1, y);
      const n11 = this.gradP[X + 1 + this.perm[Y + 1]].dot2(x - 1, y - 1);
      const u = this.fade(x);
      return this.lerp(this.lerp(n00, n10, u), this.lerp(n01, n11, u), this.fade(y));
    }
  }

  // Performance detection
  function detectPerformanceLevel() {
    let score = 1.0;
    
    if (navigator.hardwareConcurrency) {
      if (navigator.hardwareConcurrency <= 2) score = 0.4;
      else if (navigator.hardwareConcurrency <= 4) score = 0.6;
      else if (navigator.hardwareConcurrency <= 6) score = 0.8;
    }
    
    if (navigator.deviceMemory) {
      if (navigator.deviceMemory <= 2) score = Math.min(score, 0.4);
      else if (navigator.deviceMemory <= 4) score = Math.min(score, 0.7);
    }
    
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    if (isMobile) score *= 0.7;
    
    if (window.innerWidth < 768) score *= 0.8;
    
    if (navigator.connection && navigator.connection.saveData) score *= 0.5;
    
    return Math.max(0.3, Math.min(1.0, score));
  }

  function createWaves(rootEl, opts) {
    const container = rootEl.querySelector('.waves');
    const canvas = rootEl.querySelector('.waves-canvas');
    const ctx = canvas.getContext('2d', { alpha: true, desynchronized: true });
    const noise = new Noise(Math.random());
    const lines = [];
    const mouse = { x: -10, y: 0, lx: 0, ly: 0, sx: 0, sy: 0, v: 0, vs: 0, a: 0, set: false };
    const config = { ...opts };
    let bounding = { width: 0, height: 0, left: 0, top: 0 };
    let rafId = null;
    let destroyed = false;
    const interactionEl = rootEl.querySelector('.waves-content');
    let contentBox = null;
    let isVisible = true;
    let lastFrameTime = 0;
    
    // Performance-based settings
    const perfLevel = detectPerformanceLevel();
    const targetFPS = perfLevel > 0.7 ? 60 : (perfLevel > 0.5 ? 45 : 30);
    const frameInterval = 1000 / targetFPS;
    
    // Adaptive line density based on performance
    const densityMultiplier = perfLevel > 0.7 ? 1.0 : (perfLevel > 0.5 ? 0.75 : 0.6);
    config.xGap = Math.max(8, config.xGap / densityMultiplier);
    config.yGap = Math.max(20, config.yGap / densityMultiplier);
    
    console.log('Waves - Performance Level:', perfLevel.toFixed(2), 'Target FPS:', targetFPS);

    // Use OffscreenCanvas if available for better performance
    let offscreenCanvas = null;
    let offscreenCtx = null;
    if (typeof OffscreenCanvas !== 'undefined' && perfLevel > 0.6) {
      try {
        offscreenCanvas = new OffscreenCanvas(canvas.width, canvas.height);
        offscreenCtx = offscreenCanvas.getContext('2d', { alpha: true });
      } catch (e) {
        // OffscreenCanvas not supported, use regular canvas
      }
    }
    const drawCtx = offscreenCtx || ctx;

    function setSize() {
      bounding = container.getBoundingClientRect();
      const width = Math.max(1, Math.floor(bounding.width));
      const height = Math.max(1, Math.floor(bounding.height));
      canvas.width = width;
      canvas.height = height;
      
      if (offscreenCanvas) {
        offscreenCanvas.width = width;
        offscreenCanvas.height = height;
      }
    }

    function updateContentBox() {
      if (!interactionEl) { contentBox = null; return; }
      const cr = interactionEl.getBoundingClientRect();
      const br = container.getBoundingClientRect();
      const cx = cr.left - br.left + cr.width / 2;
      const cy = cr.top - br.top + cr.height / 2;
      contentBox = {
        left: cr.left - br.left,
        top: cr.top - br.top,
        width: cr.width,
        height: cr.height,
        cx, cy,
        rx: Math.max(1, cr.width / 2),
        ry: Math.max(1, cr.height / 2)
      };
    }

    function setLines() {
      lines.length = 0;
      const width = bounding.width, height = bounding.height;
      const oWidth = width + 200, oHeight = height + 30;
      const totalLines = Math.ceil(oWidth / config.xGap);
      const totalPoints = Math.ceil(oHeight / config.yGap);
      const xStart = (width - config.xGap * totalLines) / 2;
      const yStart = (height - config.yGap * totalPoints) / 2;

      for (let i = 0; i <= totalLines; i++) {
        const pts = [];
        for (let j = 0; j <= totalPoints; j++) {
          pts.push({
            x: xStart + config.xGap * i,
            y: yStart + config.yGap * j,
            wave: { x: 0, y: 0 },
            cursor: { x: 0, y: 0, vx: 0, vy: 0 }
          });
        }
        lines.push(pts);
      }
    }

    // Cache frequently used values
    const waveScaleX = 0.002;
    const waveScaleY = 0.0015;
    const waveMultiplier = 12;
    const mouseDistanceThreshold = 175;
    const mouseCosFreq = 0.001;
    const mouseForceScale = 0.00065;

    function movePoints(time) {
      const timeX = time * config.waveSpeedX;
      const timeY = time * config.waveSpeedY;
      const mouseL = Math.max(mouseDistanceThreshold, mouse.vs);
      const mouseForce = mouseL * mouse.vs * mouseForceScale;
      const cosA = Math.cos(mouse.a);
      const sinA = Math.sin(mouse.a);
      
      // Pre-calculate text box influence
      const useTextInfluence = contentBox && config.textInfluence > 0;
      const textRadius = 1.2;
      const textStrength = config.textInfluence * 0.8;

      for (let i = 0; i < lines.length; i++) {
        const pts = lines[i];
        for (let j = 0; j < pts.length; j++) {
          const p = pts[j];
          
          // Wave calculation
          const move = noise.perlin2((p.x + timeX) * waveScaleX, (p.y + timeY) * waveScaleY) * waveMultiplier;
          p.wave.x = Math.cos(move) * config.waveAmpX;
          p.wave.y = Math.sin(move) * config.waveAmpY;

          // Mouse influence
          const dx = p.x - mouse.sx;
          const dy = p.y - mouse.sy;
          const dist = Math.hypot(dx, dy);
          
          if (dist < mouseL) {
            const s = 1 - dist / mouseL;
            const f = Math.cos(dist * mouseCosFreq) * s;
            const force = f * mouseForce;
            p.cursor.vx += cosA * force;
            p.cursor.vy += sinA * force;
          }

          // Text box repulsion
          if (useTextInfluence) {
            const tx = p.x - contentBox.cx;
            const ty = p.y - contentBox.cy;
            const nd = Math.sqrt((tx * tx) / (contentBox.rx * contentBox.rx) + (ty * ty) / (contentBox.ry * contentBox.ry));
            
            if (nd < textRadius) {
              const s = (textRadius - nd) / textRadius;
              const ang = Math.atan2(ty, tx);
              const strength = s * textStrength;
              p.cursor.vx += Math.cos(ang) * strength;
              p.cursor.vy += Math.sin(ang) * strength;
            }
          }

          // Spring physics
          p.cursor.vx += (0 - p.cursor.x) * config.tension;
          p.cursor.vy += (0 - p.cursor.y) * config.tension;

          p.cursor.vx *= config.friction;
          p.cursor.vy *= config.friction;

          p.cursor.x += p.cursor.vx * 2;
          p.cursor.y += p.cursor.vy * 2;

          // Clamp values
          const maxMove = config.maxCursorMove;
          p.cursor.x = Math.min(maxMove, Math.max(-maxMove, p.cursor.x));
          p.cursor.y = Math.min(maxMove, Math.max(-maxMove, p.cursor.y));
        }
      }
    }

    function moved(point, withCursor = true) {
      const x = point.x + point.wave.x + (withCursor ? point.cursor.x : 0);
      const y = point.y + point.wave.y + (withCursor ? point.cursor.y : 0);
      return { x: Math.round(x * 10) / 10, y: Math.round(y * 10) / 10 };
    }

    function drawLines() {
      drawCtx.clearRect(0, 0, canvas.width, canvas.height);
      drawCtx.beginPath();
      drawCtx.strokeStyle = config.lineColor;
      drawCtx.lineWidth = 1;
      
      for (let i = 0; i < lines.length; i++) {
        const points = lines[i];
        let p1 = moved(points[0], false);
        drawCtx.moveTo(p1.x, p1.y);
        
        for (let idx = 0; idx < points.length; idx++) {
          const p = points[idx];
          const isLast = idx === points.length - 1;
          p1 = moved(p, !isLast);
          const p2 = moved(points[idx + 1] || points[points.length - 1], !isLast);
          drawCtx.lineTo(p1.x, p1.y);
          if (isLast) drawCtx.moveTo(p2.x, p2.y);
        }
      }
      
      drawCtx.stroke();
      
      // Copy offscreen canvas to main canvas if using it
      if (offscreenCanvas) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(offscreenCanvas, 0, 0);
      }
    }

    function tick(t) {
      if (destroyed || !isVisible) {
        rafId = requestAnimationFrame(tick);
        return;
      }
      
      // Frame rate limiting
      const elapsed = t - lastFrameTime;
      if (elapsed < frameInterval) {
        rafId = requestAnimationFrame(tick);
        return;
      }
      lastFrameTime = t - (elapsed % frameInterval);

      // Mouse smoothing
      mouse.sx += (mouse.x - mouse.sx) * 0.1;
      mouse.sy += (mouse.y - mouse.sy) * 0.1;

      const dx = mouse.x - mouse.lx;
      const dy = mouse.y - mouse.ly;
      const d = Math.hypot(dx, dy);
      mouse.v = d;
      mouse.vs += (d - mouse.vs) * 0.1;
      mouse.vs = Math.min(100, mouse.vs);
      mouse.lx = mouse.x;
      mouse.ly = mouse.y;
      mouse.a = Math.atan2(dy, dx);

      container.style.setProperty('--x', mouse.sx + 'px');
      container.style.setProperty('--y', mouse.sy + 'px');

      if (interactionEl) updateContentBox();
      movePoints(t || performance.now());
      drawLines();

      rafId = requestAnimationFrame(tick);
    }

    let resizeTimeout;
    function onResize() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        setSize();
        setLines();
      }, 150);
    }

    // Throttled mouse/touch handlers
    let lastMouseTime = 0;
    function onMouseMove(e) { 
      const now = Date.now();
      if (now - lastMouseTime < 16) return; // 60fps throttle
      lastMouseTime = now;
      updateMouse(e.clientX, e.clientY); 
    }
    
    function onTouchMove(e) { 
      const now = Date.now();
      if (now - lastMouseTime < 16) return;
      lastMouseTime = now;
      const touch = e.touches[0]; 
      if (touch) updateMouse(touch.clientX, touch.clientY); 
    }
    
    function updateMouse(x, y) {
      const b = container.getBoundingClientRect();
      mouse.x = x - b.left;
      mouse.y = y - b.top;
      if (!mouse.set) {
        mouse.sx = mouse.x; mouse.sy = mouse.y;
        mouse.lx = mouse.x; mouse.ly = mouse.y;
        mouse.set = true;
      }
    }

    // Intersection Observer for visibility detection
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        isVisible = entry.isIntersecting;
        if (isVisible) {
          lastFrameTime = performance.now();
        }
      });
    }, { threshold: 0, rootMargin: '50px' });
    observer.observe(container);

    container.style.backgroundColor = config.backgroundColor || 'transparent';
    setSize();
    setLines();
    rafId = requestAnimationFrame(tick);

    window.addEventListener('resize', onResize, { passive: true });
    window.addEventListener('mousemove', onMouseMove, { passive: true });
    window.addEventListener('touchmove', onTouchMove, { passive: true });

    return {
      destroy() {
        destroyed = true;
        cancelAnimationFrame(rafId);
        observer.disconnect();
        clearTimeout(resizeTimeout);
        window.removeEventListener('resize', onResize);
        window.removeEventListener('mousemove', onMouseMove);
        window.removeEventListener('touchmove', onTouchMove);
      }
    };
  }

  function readOpts(el) {
    const d = el.dataset;
    const num = (v, def) => (v === undefined || v === '' || isNaN(Number(v)) ? def : Number(v));
    const numClamped = (v, def, min, max) => Math.min(max, Math.max(min, num(v, def)));
    const color = (k, def) => (d[k] && d[k].trim() ? d[k] : def);
    return {
      lineColor: color('lineColor', '#000'),
      backgroundColor: color('backgroundColor', 'transparent'),
      waveSpeedX: num(d.waveSpeedX, 0.0125),
      waveSpeedY: num(d.waveSpeedY, 0.005),
      waveAmpX: num(d.waveAmpX, 32),
      waveAmpY: num(d.waveAmpY, 16),
      xGap: num(d.xGap, 10),
      yGap: num(d.yGap, 32),
      friction: numClamped(d.friction, 0.925, 0.7, 0.999),
      tension: numClamped(d.tension, 0.005, 0, 0.2),
      maxCursorMove: num(d.maxCursorMove, 100),
      textInfluence: numClamped(d.textInfluence, 0.5, 0, 2)
    };
  }

  window.WavesSection = {
    init(sectionEl) {
      const isRoot = sectionEl && sectionEl.matches && sectionEl.matches('[data-waves-section]');
      const wavesRoot = isRoot ? sectionEl : (sectionEl && sectionEl.querySelector ? sectionEl.querySelector('[data-waves-section]') : null);
      if (!wavesRoot) return;
      const opts = readOpts(wavesRoot);
      if (wavesRoot.__instance) wavesRoot.__instance.destroy();
      try {
        wavesRoot.__instance = createWaves(wavesRoot, opts);
      } catch (e) {
        console.error('Waves init error:', e);
      }
    },
    destroy(sectionEl) {
      const isRoot = sectionEl && sectionEl.matches && sectionEl.matches('[data-waves-section]');
      const wavesRoot = isRoot ? sectionEl : (sectionEl && sectionEl.querySelector ? sectionEl.querySelector('[data-waves-section]') : null);
      if (wavesRoot && wavesRoot.__instance) {
        wavesRoot.__instance.destroy();
        wavesRoot.__instance = null;
      }
    }
  };

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-waves-section]').forEach(function (el) {
      window.WavesSection.init(el);
    });
  });

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      window.WavesSection.init(e.target);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      window.WavesSection.destroy(e.target);
    });
  }
})();